export default "__VITE_ASSET__Id5CpgsL__"